module.exports = __webpack_public_path__ + "img/blog1-1.91dfc501.webp";